// GearNode catalogue — deliberately curated device base.
// Connections below describe physical, user-connectable ports. Built-in wireless
// and recording features live in metadata instead of becoming misleading node ports.

const rodeVideoS = {
  id: 'rode-rodecaster-video-s', brand: 'RØDE', model: 'RØDECaster Video S',
  type: 'Video & Audio Production Console', category: 'video', subcategory: 'switcher',
  imageUrl: '/assets/rodecaster-video-s-front-clean.png',
  technicalDiagrams: {
    front: 'https://edge.rode.com/images/page/2592/modules/12022/RCV%20S_USER%20GUIDE%20IMAGE_TOP%20VIEW%40300x.png',
    rear: 'https://edge.rode.com/images/page/2592/modules/12024/RCV%20S_USER%20GUIDE%20IMAGE_REAR%20VIEW%40300x.png',
    source: 'https://rode.com/en-int/user-guides/rodecaster-video-s',
  },
  inputs: [
    { id: 'in-hdmi1', name: 'HDMI 1', type: 'HDMI', signalType: 'video-HDMI' },
    { id: 'in-hdmi2', name: 'HDMI 2', type: 'HDMI', signalType: 'video-HDMI' },
    { id: 'in-hdmi3', name: 'HDMI 3', type: 'HDMI', signalType: 'video-HDMI' },
    { id: 'in-usb4', name: 'USB 4 (UVC / RØDE USB)', type: 'USB-C', signalType: 'video-UVC' },
    { id: 'in-ndi', name: 'NDI Input (network)', type: 'NDI', signalType: 'video-NDI', capacity: 4 },
    { id: 'in-combo1', name: 'Combo 1 (XLR / Jack)', type: 'XLR', signalType: 'audio-analog', modes: ['mic', 'line', 'instrument'] },
    { id: 'in-combo2', name: 'Combo 2 (XLR / Jack)', type: 'XLR', signalType: 'audio-analog', modes: ['mic', 'line', 'instrument'] },
    { id: 'in-power', name: 'USB-C Power', type: 'USB-C-PD', signalType: 'power' },
  ],
  outputs: [
    { id: 'out-hdmi', name: 'HDMI Out (Program / Preview / Multiview)', type: 'HDMI', signalType: 'video-HDMI' },
    { id: 'out-usb1', name: 'USB 1 (UVC / computer)', type: 'USB-C', signalType: 'video-UVC' },
    { id: 'out-usb2', name: 'USB 2 (computer / mobile)', type: 'USB-C', signalType: 'audio-USB' },
    { id: 'out-usb3', name: 'USB 3 (external SSD)', type: 'USB-C', signalType: 'data-storage' },
    { id: 'out-ndi', name: 'NDI Output (network)', type: 'NDI', signalType: 'video-NDI' },
    { id: 'out-hp1', name: 'Headphones 1', type: 'Jack', signalType: 'audio-monitor' },
    { id: 'out-hp2', name: 'Headphones 2', type: 'Jack', signalType: 'audio-monitor' },
    { id: 'out-eth', name: 'Ethernet', type: 'Ethernet', signalType: 'data' },
  ],
  supportedFormats: ['1080i50', '1080i60', '1080p25', '1080p30', '1080p50', '1080p60'],
  signalFormats: ['1080p', '1080i', 'NDI HX2', 'NDI HX3', 'UVC'],
  networkProtocols: ['NDI HX2', 'NDI HX3', 'RTMP', 'RTMPS', 'Wi-Fi', 'Ethernet'],
  audio: { streaming: '48 kHz / 32-bit', recording: '48 kHz / 24-bit', channels: 9, usbInterfaces: 3 },
  recording: { program: '1080p60', iso: '4 × 1080p30', storage: 'external USB SSD', internalMediaGb: 24 },
  description: 'Kompaktowy mikser produkcji wideo i audio: 3 × HDMI, 1 × UVC i do 4 źródeł NDI.',
  productUrl: 'https://rode.com/en-int/user-guides/rodecaster-video-s', manualUrl: 'https://rode.com/en-int/user-guides/rodecaster-video-s',
};

const sonyFx6 = {
  id: 'sony-fx6', brand: 'Sony', model: 'FX6', type: 'Cinema Line Camera',
  category: 'video', subcategory: 'camera',
  inputs: [
    { id: 'in-xlr1', name: 'INPUT 1 (XLR)', type: 'XLR', signalType: 'audio-analog', modes: ['line', 'mic', 'mic+48V'] },
    { id: 'in-xlr2', name: 'INPUT 2 (XLR)', type: 'XLR', signalType: 'audio-analog', modes: ['line', 'mic', 'mic+48V'] },
    { id: 'in-tc', name: 'TC IN (BNC)', type: 'BNC-TC', signalType: 'timecode' },
    { id: 'in-dc', name: 'DC IN (EIAJ)', type: 'DC-IN', signalType: 'power', voltage: '18–20.5 V DC' },
    { id: 'in-usbc', name: 'USB-C', type: 'USB-C', signalType: 'data', standard: 'USB 3.2 Gen 1' },
    { id: 'in-usb-multi', name: 'USB / Multi', type: 'USB-Micro-B', signalType: 'data', standard: 'USB 2.0' },
  ],
  outputs: [
    { id: 'out-sdi', name: 'SDI OUT (BNC)', type: 'SDI-12G', signalType: 'video-SDI' },
    { id: 'out-hdmi', name: 'HDMI OUT (Type A)', type: 'HDMI', signalType: 'video-HDMI' },
    { id: 'out-tc', name: 'TC OUT (BNC)', type: 'BNC-TC', signalType: 'timecode' },
    { id: 'out-headphones', name: 'Headphones', type: 'Mini-Jack', signalType: 'audio-monitor' },
  ],
  power: 18, maxPower: 36, voltage: '19.5 V DC (18.0–20.5 V)',
  supportedFormats: ['1080p25', '1080p50', '1080p60', 'uhd4k25', 'uhd4k50', 'dci4k24', 'dci4k25', 'dci4k60'],
  signalFormats: ['HD-SDI', '3G-SDI', '6G-SDI', '12G-SDI', 'HDMI'], networkProtocols: [],
  audio: { format: 'LPCM', bits: 24, sampleRateHz: 48000, channels: 4 },
  description: 'Pełnoklatkowa kamera Cinema Line. SDI OUT obsługuje 12G/6G/3G/HD-SDI, a HDMI OUT jest typu A.',
  productUrl: 'https://pro.sony/en_PL/products/handheld-camcorders/ilme-fx6v', manualUrl: '',
  source: { manual: 'SonyFX6.pdf', pages: [27, 146, 147, 148, 173, 174] },
};

const sonyFx3 = {
  id: 'sony-fx3', brand: 'Sony', model: 'FX3', type: 'Cinema Line Camera',
  category: 'video', subcategory: 'camera',
  inputs: [
    { id: 'in-mic', name: 'Microphone (3.5 mm)', type: 'Mini-Jack', signalType: 'audio-analog', modes: ['plug-in power'] },
    { id: 'in-xlr1', name: 'Handle INPUT 1 (XLR / TRS)', type: 'XLR', signalType: 'audio-analog', modes: ['line', 'mic', 'mic+48V'] },
    { id: 'in-xlr2', name: 'Handle INPUT 2 (XLR / TRS)', type: 'XLR', signalType: 'audio-analog', modes: ['line', 'mic', 'mic+48V'] },
    { id: 'in-xlr3', name: 'Handle INPUT 3 (3.5 mm)', type: 'Mini-Jack', signalType: 'audio-analog', modes: ['plug-in power'] },
    { id: 'in-usbc', name: 'USB-C (data / PD power)', type: 'USB-C-PD', signalType: 'data', standard: 'USB Power Delivery 9 V / 3 A' },
    { id: 'in-multi', name: 'Multi / Micro USB', type: 'USB-Micro-B', signalType: 'data' },
  ],
  outputs: [
    { id: 'out-hdmi', name: 'HDMI OUT (Type A)', type: 'HDMI', signalType: 'video-HDMI' },
    { id: 'out-headphones', name: 'Headphones (3.5 mm)', type: 'Mini-Jack', signalType: 'audio-monitor' },
  ],
  signalFormats: ['HDMI', 'UHD 4K', 'Full HD'], supportedFormats: ['1080p25', '1080p50', '1080p60', 'uhd4k25', 'uhd4k50', 'uhd4k60'],
  power: 7.3, voltage: 'USB-PD 9 V / 3 A recommended', networkProtocols: ['Wi-Fi', 'USB-LAN'], audio: { channels: 4 },
  description: 'Pełnoklatkowa kamera Cinema Line. W zestawie jest uchwyt XLR z wejściami INPUT 1/2 (XLR/TRS) oraz INPUT 3 (3,5 mm). Brak wyjścia SDI.',
  productUrl: 'https://pro.sony/en_PL/products/handheld-camcorders/ilme-fx3', manualUrl: '',
  source: { manual: 'Sonyfx3.pdf', pages: [1225, 2405, 2413, 2414, 2435, 2596, 2598, 2599, 3759, 3846] },
};

const rodeVideo = {
  id: 'rode-rodecaster-video', brand: 'RØDE', model: 'RØDECaster Video',
  type: 'Video & Audio Production Console', category: 'video', subcategory: 'switcher',
  inputs: [
    ...[1, 2, 3, 4].map(number => ({ id: `in-hdmi${number}`, name: `HDMI ${number}`, type: 'HDMI', signalType: 'video-HDMI' })),
    { id: 'in-usb4', name: 'USB 4 (UVC / webcam)', type: 'USB-C', signalType: 'video-UVC' },
    { id: 'in-usb5', name: 'USB 5 (UVC / webcam)', type: 'USB-C', signalType: 'video-UVC' },
    { id: 'in-ndi', name: 'NDI Input (network)', type: 'NDI', signalType: 'video-NDI', capacity: 4 },
    { id: 'in-combo1', name: 'Combo 1 (XLR / Jack)', type: 'XLR', signalType: 'audio-analog', modes: ['mic', 'line', 'instrument'] },
    { id: 'in-combo2', name: 'Combo 2 (XLR / Jack)', type: 'XLR', signalType: 'audio-analog', modes: ['mic', 'line', 'instrument'] },
    { id: 'in-power', name: 'USB-C Power', type: 'USB-C-PD', signalType: 'power' },
  ],
  outputs: [
    { id: 'out-hdmi-a', name: 'HDMI A (configurable)', type: 'HDMI', signalType: 'video-HDMI' },
    { id: 'out-hdmi-b', name: 'HDMI B (configurable)', type: 'HDMI', signalType: 'video-HDMI' },
    { id: 'out-usb1', name: 'USB 1 (computer / UVC)', type: 'USB-C', signalType: 'video-UVC' },
    { id: 'out-usb2', name: 'USB 2 (computer / mobile)', type: 'USB-C', signalType: 'audio-USB' },
    { id: 'out-usb3', name: 'USB 3 (external SSD)', type: 'USB-C', signalType: 'data-storage' },
    { id: 'out-ndi', name: 'NDI Output (network)', type: 'NDI', signalType: 'video-NDI' },
    { id: 'out-monitor-l', name: 'Monitor L', type: 'Jack', signalType: 'audio-analog' },
    { id: 'out-monitor-r', name: 'Monitor R', type: 'Jack', signalType: 'audio-analog' },
    { id: 'out-hp1', name: 'Headphones 1', type: 'Jack', signalType: 'audio-monitor' },
    { id: 'out-hp2', name: 'Headphones 2', type: 'Jack', signalType: 'audio-monitor' },
    { id: 'out-eth', name: 'Ethernet', type: 'Ethernet', signalType: 'data' },
  ],
  supportedFormats: ['1080i50', '1080i60', '1080p23.98', '1080p24', '1080p25', '1080p29.97', '1080p30', '1080p50', '1080p59.94', '1080p60'],
  signalFormats: ['1080p', '1080i', 'NDI HX2', 'NDI HX3', 'UVC'], networkProtocols: ['NDI HX2', 'NDI HX3', 'RTMP', 'RTMPS', 'Wi-Fi', 'Ethernet'],
  recording: { program: '1080p60', iso: '6 × 1080p30', storage: 'microSD / external USB SSD' },
  description: 'Mikser produkcji z 4 wejściami HDMI, 2 wejściami USB UVC, NDI i dwoma konfigurowalnymi wyjściami HDMI.',
  productUrl: 'https://rode.com/en-int/user-guides/rodecaster-video', manualUrl: 'https://rode.com/en-int/user-guides/rodecaster-video',
};

const rodeDuo = {
  id: 'rode-rodecaster-duo', brand: 'RØDE', model: 'RØDECaster Duo', type: 'Integrated Audio Production Studio',
  category: 'audio', subcategory: 'console',
  inputs: [
    { id: 'in-combo1', name: 'Combo 1 (XLR / Jack)', type: 'XLR', signalType: 'audio-analog', modes: ['mic', 'line', 'instrument'] },
    { id: 'in-combo2', name: 'Combo 2 (XLR / Jack)', type: 'XLR', signalType: 'audio-analog', modes: ['mic', 'line', 'instrument'] },
    { id: 'in-headset', name: 'Headset (3.5 mm TRRS)', type: 'Mini-Jack', signalType: 'audio-analog' },
    { id: 'in-usb1', name: 'USB 1 (computer)', type: 'USB-C', signalType: 'audio-USB' },
    { id: 'in-usb2', name: 'USB 2 (computer / mobile)', type: 'USB-C', signalType: 'audio-USB' },
    { id: 'in-power', name: 'USB-C Power (9 V / 3 A)', type: 'USB-C-PD', signalType: 'power' },
  ],
  outputs: [
    { id: 'out-line-l', name: 'Line Out L', type: 'Jack', signalType: 'audio-analog' },
    { id: 'out-line-r', name: 'Line Out R', type: 'Jack', signalType: 'audio-analog' },
    { id: 'out-hp1', name: 'Headphones 1', type: 'Jack', signalType: 'audio-monitor' },
    { id: 'out-hp2', name: 'Headphones 2', type: 'Jack', signalType: 'audio-monitor' },
    { id: 'out-usb1', name: 'USB 1 audio', type: 'USB-C', signalType: 'audio-USB' },
    { id: 'out-usb2', name: 'USB 2 audio', type: 'USB-C', signalType: 'audio-USB' },
    { id: 'out-eth', name: 'Ethernet', type: 'Ethernet', signalType: 'data' },
  ],
  audio: { sampleRateHz: 48000, usb1: '32-bit', usb2: '24-bit', usbInterfaces: 3 },
  networkProtocols: ['Wi-Fi', 'Ethernet', 'Bluetooth'], recording: { storage: 'microSD / external USB', internalMediaGb: 4 },
  description: 'Kompaktowe studio audio: 2 wejścia combo, TRRS headset, 2 wyjścia słuchawkowe oraz podwójne USB-C.',
  productUrl: 'https://rode.com/en-int/user-guides/rodecaster-duo', manualUrl: 'https://rode.com/en-int/user-guides/rodecaster-duo',
};

const rodeProII = {
  id: 'rode-rodecaster-pro-ii', brand: 'RØDE', model: 'RØDECaster Pro II', type: 'Integrated Audio Production Studio',
  category: 'audio', subcategory: 'console',
  inputs: [
    ...[1, 2, 3, 4].map(number => ({ id: `in-combo${number}`, name: `Combo ${number} (XLR / Jack)`, type: 'XLR', signalType: 'audio-analog', modes: ['mic', 'line', 'instrument'] })),
    { id: 'in-usb1', name: 'USB 1 (computer)', type: 'USB-C', signalType: 'audio-USB' },
    { id: 'in-usb2', name: 'USB 2 (computer / mobile)', type: 'USB-C', signalType: 'audio-USB' },
    { id: 'in-power', name: 'USB-C Power (15 V / 2 A)', type: 'USB-C-PD', signalType: 'power' },
  ],
  outputs: [
    { id: 'out-line-l', name: 'Line Out L', type: 'Jack', signalType: 'audio-analog' },
    { id: 'out-line-r', name: 'Line Out R', type: 'Jack', signalType: 'audio-analog' },
    ...[1, 2, 3, 4].map(number => ({ id: `out-hp${number}`, name: `Headphones ${number}`, type: 'Jack', signalType: 'audio-monitor' })),
    { id: 'out-usb1', name: 'USB 1 audio', type: 'USB-C', signalType: 'audio-USB' },
    { id: 'out-usb2', name: 'USB 2 audio', type: 'USB-C', signalType: 'audio-USB' },
    { id: 'out-eth', name: 'Ethernet', type: 'Ethernet', signalType: 'data' },
  ],
  audio: { sampleRateHz: 48000, usb1: '32-bit', usb2: '24-bit', usbInterfaces: 3 },
  networkProtocols: ['Wi-Fi', 'Ethernet', 'Bluetooth'], recording: { storage: 'microSD / external USB', internalMediaGb: 4 },
  description: 'Studio audio z 4 wejściami combo, 4 niezależnymi wyjściami słuchawkowymi i podwójnym USB-C.',
  productUrl: 'https://rode.com/en-int/user-guides/rodecaster-pro-ii', manualUrl: 'https://rode.com/en-int/user-guides/rodecaster-pro-ii',
};

const rodeHdmiUsbConverter = {
  id: 'rode-hdmi-usb-c-converter', brand: 'RØDE', model: 'HDMI to USB-C Converter',
  type: 'HDMI capture converter', category: 'video', subcategory: 'converter', assetKind: 'converter',
  inputs: [{ id: 'in-hdmi', name: 'HDMI IN', type: 'HDMI', signalType: 'video-HDMI' }],
  outputs: [{ id: 'out-usbc', name: 'USB-C UVC (integrated cable)', type: 'USB-C', signalType: 'video-UVC', integratedCable: true }],
  supportedFormats: ['1080p25', '1080p30', '1080p50', '1080p60'], signalFormats: ['1080p60', 'UVC'], power: 15,
  description: 'Jednokierunkowy konwerter HDMI → USB-C UVC 1080p60. Wbudowany przewód USB-C; do planowania potrzebuje tylko kabla HDMI po stronie wejścia.',
  productUrl: 'https://rode.com/en-int/products/hdmi-usb-c-converter', manualUrl: 'https://edge.rode.com/pdf/products/1486/HDMI%20to%20USB-C_Datasheet.pdf',
  source: { datasheet: 'HDMI to USB-C Converter Datasheet', checkedAt: '2026-09-15' },
};

export const DEVICE_CATALOG = [sonyFx6, sonyFx3, rodeVideoS, rodeVideo, rodeDuo, rodeProII, rodeHdmiUsbConverter];
export const getCatalogByCategory = category => DEVICE_CATALOG.filter(device => device.category === category);
export const getCatalogBySubcategory = subcategory => DEVICE_CATALOG.filter(device => device.subcategory === subcategory);
export const searchCatalog = query => {
  const normalizedQuery = query.toLowerCase();
  return DEVICE_CATALOG.filter(device => `${device.brand} ${device.model} ${device.type} ${device.description}`.toLowerCase().includes(normalizedQuery));
};
export const MASTER_CATALOG = DEVICE_CATALOG;
